(() => {
  const SELECTOR = '[data-sa-cart-upsell]';
  const GRID_SELECTOR = '[data-sa-cart-upsell-grid]';
  const ADD_BUTTON_SELECTOR = '[data-sa-upsell-add]';
  const CART_DRAWER_SECTION_ID = 'cart-drawer';
  const CART_ITEMS_SECTION_ID = 'cart-items';
  let scheduled = false;

  // Op de losse /cart-pagina zelf mag een add-up-klik nooit de drawer
  // openen — je kijkt daar al naar de volledige winkelwagen.
  const isOnCartPage = () => {
    const cartPath = (window.routes?.cart_url || '/cart').split('?')[0].replace(/\/$/, '');
    const currentPath = window.location.pathname.replace(/\/$/, '');
    return currentPath === cartPath;
  };

  const log = (message) => {
    if (window.devLog) window.devLog('CartUpsell', message);
  };

  const getRenderedProductIds = (container) => {
    return Array.from(container.querySelectorAll('[data-sa-cart-upsell-product-id]')).map((item) =>
      String(item.getAttribute('data-sa-cart-upsell-product-id'))
    );
  };

  const finalizeContainer = (container, shouldShow) => {
    container.setAttribute('data-loaded', 'true');

    if (!shouldShow) {
      container.style.display = 'none';
      return;
    }

    container.style.display = '';
  };

  const scheduleFrame = (callback) => {
    if ('requestAnimationFrame' in window) {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(callback);
      });
      return;
    }

    setTimeout(callback, 32);
  };

  const getCartContainer = () => document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const getRequestConfig = () => {
    const fallbackConfig = {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
      },
    };
    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : fallbackConfig;

    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    return config;
  };

  const setButtonLoading = (button, isLoading) => {
    const spinner = button.querySelector('.loading__spinner');

    button.classList.toggle('loading', isLoading);
    button.disabled = isLoading;

    if (isLoading) {
      button.setAttribute('aria-disabled', 'true');
      spinner?.classList.remove('hidden');
      return;
    }

    button.removeAttribute('aria-disabled');
    spinner?.classList.add('hidden');
  };

  // Ververst de inhoud van de al-open drawer in stilte (zonder cart.open() aan
  // te roepen). cart.renderContents() roept intern namelijk ook open() aan, en
  // dat blijkt — wanneer de drawer al open staat, zoals hier — de pagina
  // erachter soms terug naar boven te laten springen. Door de sectie-HTML
  // handmatig in #CartDrawer te zetten, blijft de drawer gewoon staan zoals
  // die stond en scrolt de achtergrond niet mee.
  const refreshCartDrawerQuietly = (cart, response) => {
    try {
      const sectionHtml = response && response.sections && response.sections[CART_DRAWER_SECTION_ID];
      if (!sectionHtml) return false;

      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const src = parsed.querySelector('#CartDrawer');
      const dest = document.querySelector('#CartDrawer');
      const srcHtml = src ? src.innerHTML || '' : '';

      if (!src || !dest || srcHtml.replace(/\s+/g, '').length < 30) return false;

      dest.innerHTML = srcHtml;
      cart.classList.remove('is-empty');
      const innerEl = cart.querySelector('.drawer__inner');
      if (innerEl) innerEl.classList.remove('is-empty');
      return true;
    } catch (error) {
      return false;
    }
  };

  // Ververst de winkelwagen-tabel + add-ups op de losse /cart-pagina zelf,
  // zonder de drawer aan te raken (dus geen .open() en geen sidebar die
  // verschijnt). Dezelfde sectie ("cart-items") die de pagina normaal
  // server-side rendert, wordt hier gewoon opnieuw ingezet.
  const refreshCartItemsSectionQuietly = (response) => {
    try {
      const sectionHtml = response && response.sections && response.sections[CART_ITEMS_SECTION_ID];
      if (!sectionHtml) return false;

      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const src = parsed.getElementById(`shopify-section-${CART_ITEMS_SECTION_ID}`) || parsed.querySelector('.shopify-section');
      const dest = document.getElementById(`shopify-section-${CART_ITEMS_SECTION_ID}`);

      if (!src || !dest) return false;

      dest.innerHTML = src.innerHTML;
      return true;
    } catch (error) {
      return false;
    }
  };

  const refreshCartIconBubbleQuietly = (response) => {
    try {
      const sectionHtml = response && response.sections && response.sections['cart-icon-bubble'];
      if (!sectionHtml) return;
      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('.shopify-section');
      const target = document.getElementById('cart-icon-bubble');
      if (parsed && target) target.innerHTML = parsed.innerHTML;
    } catch (error) {}
  };

  // Dawn's eigen winkelwagen-tabel (hoeveelheid wijzigen / regel verwijderen
  // via de knoppen op de /cart-pagina zelf) ververst alléén de tabel, niet
  // ons add-up-blok ernaast — dat blijft dus achter met verouderde add-ups
  // (bijv. nog steeds "compatibele accessoires" tonen terwijl de dashcam er
  // net uit is gehaald). Daarom: bij ELKE winkelwagen-wijziging op de
  // cart-pagina (ook als die niet van onszelf komt) het add-up-blok apart
  // opnieuw ophalen en vervangen, los van Dawn's eigen tabel-update.
  const refreshCartUpsellOnCartPage = () => {
    if (!isOnCartPage()) return;

    // Let op: dit "?section_id=" GET-verzoek gebruikt een ANDERE naam dan de
    // "sections"-array in de /cart/add.js en /cart/change.js POST-calls.
    // Daar is "cart-items" (de sectie-ID uit templates/cart.json) correct,
    // maar voor dit GET-endpoint verwacht Shopify hier "main-cart-items"
    // (de bestandsnaam) — exact zoals Dawn's eigen cart.js dat ook doet in
    // onCartUpdate(). Door dit te verwarren kreeg dit verzoek een 404 en
    // gebeurde er dus stilletjes niets.
    fetch(`${window.location.pathname}?section_id=main-cart-items`)
      .then((response) => (response.ok ? response.text() : null))
      .then((html) => {
        if (!html) return;

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const freshUpsell = parsed.querySelector(SELECTOR);

        // Let op: er staat OOK een add-up-blok in de (verborgen) cart-drawer
        // op dezelfde pagina. Een kale document.querySelector(SELECTOR) pakt
        // altijd het EERSTE exemplaar in de HTML-volgorde — en dat is de
        // drawer, want cart-drawer.liquid wordt bovenaan <body> gerenderd,
        // vóór de echte /cart-inhoud. Daardoor werd steeds het onzichtbare
        // drawer-blok ververst met de juiste dashcams, terwijl het blok dat
        // je op de pagina zelf ziet nooit werd aangeraakt (pas na een volledige
        // page refresh klopte het weer, want dan rendert de server alles
        // opnieuw opnieuw).
        //
        // Fix: scope op het <cart-items> custom element (de main-page
        // wrapper uit main-cart-items.liquid). Let op: dit is NIET hetzelfde
        // als de #main-cart-items DIV — die omvat alleen de producttabel,
        // het add-up-blok staat daar als sibling náást (buiten die div),
        // dus scopen op #main-cart-items zelf vindt het blok ook niet.
        const cartItemsScope = document.querySelector('cart-items');
        const liveUpsell = cartItemsScope ? cartItemsScope.querySelector(SELECTOR) : document.querySelector(SELECTOR);

        if (!liveUpsell) return;

        if (!freshUpsell) {
          // Geen add-ups meer te tonen (bijv. winkelwagen nu helemaal leeg).
          liveUpsell.remove();
          return;
        }

        liveUpsell.replaceWith(freshUpsell);
        initAll();
      })
      .catch(() => {});
  };

  const addUpsellItemToCart = (button) => {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const cart = getCartContainer();
    const onCartPage = isOnCartPage();
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    const sectionsToRender = cart?.getSectionsToRender ? cart.getSectionsToRender().map((section) => section.id) : [];
    if (onCartPage) {
      if (!sectionsToRender.includes(CART_ITEMS_SECTION_ID)) sectionsToRender.push(CART_ITEMS_SECTION_ID);
      if (!sectionsToRender.includes('cart-icon-bubble')) sectionsToRender.push('cart-icon-bubble');
    }

    if (sectionsToRender.length) {
      formData.append('sections', sectionsToRender);
      formData.append('sections_url', window.location.pathname);
    }
    if (!onCartPage) {
      cart?.setActiveElement?.(button);
    }

    const config = getRequestConfig();
    config.body = formData;

    setButtonLoading(button, true);

    fetch(`${window.routes?.cart_add_url || '/cart/add'}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartError) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'cart-upsell',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
          }

          log(`Add to cart failed: ${response.description || response.message || 'Unknown error'}`);
          return;
        }

        if (onCartPage) {
          // Op de losse /cart-pagina zelf: nooit de drawer openen, je kijkt
          // daar al naar de volledige winkelwagen. Alleen de tabel + add-ups
          // in stilte verversen (en de winkelwagen-teller in de header).
          refreshCartIconBubbleQuietly(response);
          const refreshed = refreshCartItemsSectionQuietly(response);
          if (!refreshed) {
            window.location.reload();
            return;
          }
          initAll();
        } else if (cart && cart.classList.contains('active')) {
          // De drawer staat al open (je voegt toe vanuit een upsell in de
          // drawer zelf): inhoud in stilte verversen, niet opnieuw openen.
          const refreshed = refreshCartDrawerQuietly(cart, response);
          if (!refreshed && cart.renderContents) {
            cart.renderContents(response);
          }
          initAll();
        } else if (cart?.renderContents) {
          cart.renderContents(response);
          initAll();
        } else {
          window.location.href = window.routes?.cart_url || '/cart';
          return;
        }

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-upsell',
            productVariantId: variantId,
            cartData: response,
          });
        }
      })
      .catch((error) => {
        log(`Add to cart error: ${error.message}`);
      })
      .finally(() => {
        setButtonLoading(button, false);
      });
  };

  const bindGlobalActions = () => {
    const root = document.documentElement;
    if (!root) return;

    if (window.initOnce && !window.initOnce(root, 'cart-upsell-actions')) {
      return;
    }

    root.addEventListener('click', (event) => {
      const button = event.target.closest(ADD_BUTTON_SELECTOR);
      if (!button) return;

      const container = button.closest(SELECTOR);
      if (!container) return;

      if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
        return;
      }

      event.preventDefault();
      addUpsellItemToCart(button);
    });
  };

  const initContainer = (container) => {
    if (!container) return;

    if (window.SA_THEME && window.SA_THEME.cartUpsellEnabled !== true) {
      log('Disabled via toggle');
      return;
    }

    if (window.initOnce && !window.initOnce(container, 'cart-upsell')) {
      return;
    }

    const grid = container.querySelector(GRID_SELECTOR);
    if (!grid) return;

    const existingCount = getRenderedProductIds(container).length;
    finalizeContainer(container, existingCount > 0);
    log(`Initialized ${existingCount} curated accessories`);
  };

  const initAll = () => {
    if (window.SA_THEME && window.SA_THEME.cartUpsellEnabled !== true) {
      return;
    }

    const containers = document.querySelectorAll(SELECTOR);
    if (!containers.length) return;

    containers.forEach(initContainer);
  };

  const scheduleInit = () => {
    if (scheduled) return;
    scheduled = true;

    const run = () => {
      scheduled = false;
      initAll();
    };

    scheduleFrame(run);
  };

  bindGlobalActions();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  // Let op: PUB_SUB_EVENTS wordt met "const" gedeclareerd in Dawn's eigen
  // scripts, dus die hangt NOOIT aan window (ook niet als classic script).
  // window.PUB_SUB_EVENTS is daardoor altijd undefined — de kale naam
  // (via de normale scope chain) moet gebruikt worden, niet window.*.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      scheduleInit();

      // Onze eigen add-up-klik ververst de sectie al zelf (zie
      // addUpsellItemToCart); alleen bij wijzigingen van elders (Dawn's
      // eigen tabel op de cart-pagina, de keuzehulp, etc.) opnieuw ophalen.
      if (event && event.source === 'cart-upsell') return;
      refreshCartUpsellOnCartPage();
    });
  }
})();